export default {
  service: {
    quantityTakeOff: {
      serviceLevel: 'Standard',
      turnaround: '7Day',
      reportLevel: 'Comprehensive',
      healthAndSafety: false,
      premierBound: false,
      eppCustomer: false,
      jobType: null,
    },
    internalTakeOff: {
      turnaround: '2Day',
    },
    designService: {
      serviceLevel: 'Standard',
      turnaround: '5Day',
      reportLevel: 'Comprehensive'
    },
    buildKickOff: {
      serviceLevel: 'Standard',
      turnaround: '5Day',
      reportLevel: 'Comprehensive'
    },
    sap: {},
    airTightness: {},
    acousticTesting: {},
    sbem: {},
    liteEstimating: {
      reportLevel: 'Standard',
    },
    primaryCostEstimate: {
      jobType: null,
    }
  },
  quoteInfo: {
    builder: {
      name: null,
      buildersName: null,
      telephone: null,
      telephoneSecondary: null,
      email: null,
      invoiceEmail: null,
      type: null,
      address: {
        line1: null,
        line2: null,
        town: null,
        postcode: null
      }
    },
    branch: {
      label: null,
      name: null,
      number: null,
      region: null,
      area: null,
      areaName: null,
      localBusinessUnit: null,
      businessUnitDirector: null,
      salesManager: null,
      tsm: null,
      address: {
        line1: null,
        line2: null,
        town: null,
        postcode: null
      },
      contactName: null,
      telephone: null,
      email: null,
      accountNumber: null
    },
    customer: {
      name: null,
      telephone: null,
      startDate: null,
      buildingRegs: null,
      typeOfBuilding: null,
      address: {
        line1: null,
        line2: null,
        town: null,
        postcode: null
      }
    }
  },
  requestedServices: {
    quantityTakeOff: true,
    sap: false,
    airTightness: false,
    acousticTesting: false,
    sbem: false,
    internalTakeOff: false,
    designService: false
  },
  requestedQuotes: {
    roofTrusses: false,
    kitchen: false,
    bathroom: false,
    aluminiumWindowsAndDoors: false,
    timberWindows: false,
    pvcuWindowsAndDoors: false,
    landscaping: false,
    roofLights: false,
    hollowCoreFloors: false,
    floorFinishes: false,
    externalRendering: false,
    artStone: false,
    bricks: false,
    acoustics: false,
    underfloorHeating: false,
    timberDoors: false
  },
  labourRates: {
    labourer: 21.88,
    painter: 31.25,
    brickLayerLabourer: 21.88,
    plastererLabourer: 21.88,
    plumber: 35,
    electrician: 35,
    groundWorker: 31.25,
    artexer: 31.25,
    bricklayer: 31.25,
    glazier: 31.25,
    carpenter: 31.25,
    cleaner: 21.88,
    siteForeman: 31.25,
    scaffolder: 31.25,
    roofTiler: 31.25,
    leadWorker: 31.25,
    flatRoofer: 31.25,
    plasterer: 31.25,
    ceramicTiler: 31.25,
    apprentice: 21.88,
    banksman: 35,
    steelErector: 40,
    windowInstaller: 40,
    specialistContractor: 40,
  },
  markUp: {
    plant: 0,
    materials: 30,
    labour: 20,
    pcSums: 0,
    overheads: 0
  },
}